export const findMaxInDataSlice = (datasets = [], axisId, startIndex, endIndex) => {
    let overallMax = -Infinity; 

    datasets.forEach(dataset => {
        // Determine the target axis for the current dataset (default to 'y')
        const datasetAxis = dataset.yAxisID === 'y1' ? 'y1' : 'y'; 
        
        if (datasetAxis === axisId && Array.isArray(dataset.data)) {
             const dataSlice = dataset.data.slice(startIndex, endIndex);
             const validNumbers = dataSlice.filter(val => typeof val === 'number' && !isNaN(val));
             
             if (validNumbers.length > 0) {
                const currentMax = Math.max(...validNumbers);
                if (currentMax > overallMax) {
                    overallMax = currentMax;
                }
             }
        }
    });
    
    // Return 0 if no valid data points were found in the slice for this axis
    return overallMax === -Infinity ? 0 : overallMax; 
};